export class DocSubCategory {
    Id: number = null;
    DocCatId: number = null;
    Name: string = null;
    Remarks: string = null;
    IsActive: boolean; 
    TenantId: number = null;
    CreatedDtTm: string = null;
    ModifiedDtTm: string = null;
  }